import classNames from 'classnames';
import React from 'react';

import { Button, LinkButton } from '@eika/button';
import { ConfirmationDialog } from '@eika/confirmation-dialog';
import { ConfirmationDialogProps } from '@eika/confirmation-dialog/lib/ConfirmationDialog';
import { Label } from '@eika/label';

import useTranslation from '../hooks/useTranslation';

import './SigningConfirmationDialog.scss';

export type SigningConfirmationProps = { confirmText: string; onConfirm: () => void; labelText?: string } & Omit<
    ConfirmationDialogProps,
    'footer'
>;

const SigningConfirmationDialog: React.FC<SigningConfirmationProps> = ({
    confirmText,
    onConfirm,
    labelText,
    ...rest
}) => {
    const translated = useTranslation();
    return (
        <ConfirmationDialog
            className={classNames('signing-confirmation-dialog', {
                'no-description': !rest.description,
            })}
            footer={
                <div className="signing-confirmation-dialog__content-wrapper">
                    {labelText && <Label type="warning" text={labelText} />}
                    <div
                        className={classNames('signing-confirmation-dialog__content-button-wrapper', {
                            'with-label': !!labelText,
                        })}
                    >
                        <LinkButton onClick={rest.onExitFocus}>{translated.cancel}</LinkButton>
                        <Button onClick={onConfirm}>{confirmText}</Button>
                    </div>
                </div>
            }
            {...rest}
        />
    );
};

export default SigningConfirmationDialog;
